import React from 'react';
import CustomDropdown from '../dropdown/CustomDropDown';
// import DropdownItem from 'react-bootstrap/DropdownItem';
import styled, { useTheme } from 'styled-components';
import StyledImage from './StyledImage';
import NotificationBellIcon from '../svgIcons/NotificationBellIcon';
import StyledButton from './StyledButton';
import SettingsIcon from '../svgIcons/SettingsIcon';
import {
  StyledLabel,
  StyledSpan,
  Wrap,
} from '../../../assets/styledComponents/Global';
import StyledDot from './StyledDot';
import moment from 'moment';
import { handleErrorImg } from '../../../utils/helper';
import { useNavigate } from 'react-router';
import { setNotifictionData } from '../../../features/Setting/Notifications/Apis/notificationsDataSlice';
import { useDispatch } from 'react-redux';
import { useMarkNotifAsReadMutation } from '../../../features/Setting/Notifications/Apis/notificationApiSlice';
import useAuth from '../../../hooks/useAuth';
import EmptyState from '../nodata/EmptyState';
const NotificationDropDown = ({
  toggleClassName,
  menuClassName,
  profile,
  notifications,
  totalUnreadNotifications,
  refetch,
}) => {
  const theme = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [markNotifRead] = useMarkNotifAsReadMutation();
  const formattedTime = (date) => {
    return moment(date).format('LT');
  };
  const ViewAlNotifications = () => {
    dispatch(setNotifictionData(refetch));
    navigate('/notifications', {
      state: { notifications, totalUnreadNotifications },
    });
  };
  const markRead = (item) => {
    markNotifRead(item?.id, { skip: !item?.id })
      .unwrap()
      .then((res) => {
        // toast.success(res?.message || 'Marked as read successfully');
        refetch();
      });
  };

  return (
    <ProfileDropDownStyle>
      <CustomDropdown
        toggleClassName={toggleClassName}
        menuClassName={menuClassName}
        dropdownToggle={
          <div
            className={`account-menu ${toggleClassName} ${
              user?.accountType === 2 && user?.company?.isParent === 1
                ? 'd-none'
                : ''
            } position-relative`}
          >
            <div
              className={`edit-icon-wrapper account-img   ${!profile?.image ? 'default' : ''}`}
            >
              <NotificationBellIcon size={20} color="#ffffff" />
            </div>
            {notifications?.map((item, index) =>
              item?.read === 0 ? (
                <StyledDot
                  key={index}
                  color={theme?.dark ? theme?.darkDoubleRed : theme.danger}
                  $position="absolute"
                  $top="-2px"
                  $right="-2px"
                  $border="2px solid #fff"
                  $size="8px"
                />
              ) : null,
            )}
          </div>
        }
        dropdownMenu={
          <Wrap className="dropDown">
            <PanelHeader>
              <StyledLabel size="18px" weight="700" color={theme.headingColor}>
                Notifications
              </StyledLabel>
              <StyledIcon className="feature-pending">
                <SettingsIcon size="17px" color={theme.headingColor} />
              </StyledIcon>
            </PanelHeader>
            {notifications?.length ? (
              <>
                <StyledScrollNoteViewer>
                  {notifications?.map((item, index) => {
                    const isUnread = item.read === 0;
                    return (
                      <NotifRow
                        $unread={isUnread}
                        className="cursor-pointer"
                        onClick={() => markRead(item)}
                        key={item?.id || index}
                      >
                        <div className="d-flex mx-3 align-items-start py-1">
                          <div className="col-2 position-relative">
                            <StyledImage height={'48px'} width={'48px'}>
                              <img
                                src={item?.notification_icon}
                                alt="img"
                                onError={handleErrorImg}
                              />
                            </StyledImage>
                            {isUnread ? (
                              <RowUnreadDot
                                color={theme?.secondary || '#dc601e'}
                                $position="absolute"
                                $top="0"
                                $right="4px"
                                $size="8px"
                              />
                            ) : null}
                          </div>
                          <div className="col-10 ps-3 d-flex flex-column">
                            <NotifBody>
                              {item?.message?.map((data, i) => (
                                <StyledSpan
                                  color={
                                    isUnread
                                      ? theme?.headingColor || theme?.lightBoldBlack
                                      : theme?.textMuted || theme?.inputPlaceHolder
                                  }
                                  className={`me-1 ${
                                    isUnread && data?.bold ? 'fw-semibold' : data?.bold ? 'fw-medium' : ''
                                  }`}
                                  key={`${item?.id || index}-msg-${i}`}
                                >
                                  {data?.text}
                                </StyledSpan>
                              ))}
                            </NotifBody>
                            <StyledLabel
                              size="12px"
                              weight={500}
                              color={theme.inputPlaceHolder}
                              className="mt-1 mb-0"
                            >
                              {formattedTime(item?.created_at)}
                            </StyledLabel>
                          </div>
                        </div>
                      </NotifRow>
                    );
                  })}
                </StyledScrollNoteViewer>

                <PanelFooter>
                  <StyledButton
                    variant="white"
                    className="col-12"
                    onClick={ViewAlNotifications}
                  >
                    View All Notifications
                  </StyledButton>
                </PanelFooter>
              </>
            ) : (
              <div className="px-3 pb-3">
                <EmptyState
                  title="No notifications yet"
                  description="Updates about jobs, candidates, and offers will show up here."
                  compact
                />
              </div>
            )}
          </Wrap>
        }
      />
    </ProfileDropDownStyle>
  );
};

const StyledIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: ${({ theme }) =>
    theme?.dark ? theme.fieldLabelBg || '#343B45' : '#f4f5f7'};
  color: ${({ theme }) => theme.headingColor};
  border-radius: 50%;
`;

const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 8px;
`;

const PanelFooter = styled.div`
  padding: 8px 16px 16px;
`;

const ProfileDropDownStyle = styled.div`
  .custom-drop-down .menu-dropdown.dropdown-menu {
    width: 360px;
    padding: 0 !important;
    overflow: hidden;
    border-radius: ${({ theme }) => theme.radiusCard || '10px'} !important;
    background: ${({ theme }) =>
      theme?.dark ? theme.surface || '#28303A' : '#fff'} !important;
    border: 1px solid
      ${({ theme }) =>
        theme?.dark
          ? 'rgba(255, 255, 255, 0.16)'
          : 'rgba(13, 35, 73, 0.08)'} !important;
    box-shadow: ${({ theme }) =>
      theme?.dark
        ? '0 12px 28px rgba(0, 0, 0, 0.4)'
        : theme.shadowCard || '0 8px 24px rgba(13, 35, 73, 0.12)'} !important;
    color: ${({ theme }) => theme.headingColor};
  }

  .custom-drop-down .menu-dropdown.dropdown-menu .btn {
    color: ${({ theme }) =>
      theme?.dark ? theme.headingColor || '#fff' : theme.primaryDark || '#0d2349'} !important;
    background: transparent !important;
    border: 1px solid
      ${({ theme }) =>
        theme?.dark ? 'rgba(255, 255, 255, 0.34)' : 'rgba(13, 35, 73, 0.22)'} !important;
    border-radius: 10px !important;
    font-weight: 600;
    min-height: 40px;

    &:hover,
    &:focus,
    &:active {
      color: ${({ theme }) =>
        theme?.dark ? '#fff' : theme.primaryDark || '#0d2349'} !important;
      background: ${({ theme }) =>
        theme?.dark ? 'rgba(255, 255, 255, 0.08)' : '#f4f5f7'} !important;
      border-color: ${({ theme }) =>
        theme?.dark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(13, 35, 73, 0.35)'} !important;
      box-shadow: none !important;
      opacity: 1;
    }
  }

  .menu-toggle {
    padding-block: 0;
  }
  .dropDown {
    width: 100%;
  }
  .account-menu {
    display: flex;
    align-items: center;
    h6 {
      font-size: 14px;
      font-weight: 600;
      margin: 0;
    }
  }
  h6 {
    word-break: break-all;
    white-space: pre-wrap;
  }
  .time {
    color: ${({ theme }) => theme.inputPlaceHolder};
  }
  .account-img {
    border-radius: 5px;
    overflow: hidden;
    // margin-right: 8px;

    &.default {
      background-color: ${({ theme }) => theme.defaultImage};
      border-radius: 50%;
      color: ${({ theme }) => theme.white};
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
`;

const NotifRow = styled.div`
  position: relative;
  margin: 0 8px 6px;
  padding: 8px 0;
  border-radius: ${({ theme }) => theme?.radiusSm || '8px'};
  background: ${({ $unread, theme }) =>
    $unread
      ? theme?.dark
        ? theme.fieldLabelBg || '#343B45'
        : '#EFF4FA'
      : 'transparent'};
  border-left: 3px solid
    ${({ $unread, theme }) =>
      $unread ? theme?.secondary || '#dc601e' : 'transparent'};
  opacity: ${({ $unread }) => ($unread ? 1 : 0.78)};

  &:hover {
    background: ${({ theme }) =>
      theme?.dark ? 'rgba(255, 255, 255, 0.06)' : '#f4f5f7'};
    opacity: 1;
  }
`;

const NotifBody = styled.div`
  line-height: 1.35;
  font-size: 13px;
`;

const RowUnreadDot = styled(StyledDot)``;

const StyledScrollNoteViewer = styled.div`
  max-height: 310px;
  max-width: 520px;
  overflow: auto;
  word-wrap: break-word;
  @-moz-document url-prefix() {
    scrollbar-width:thin;
        scrollbar-color: #c8c8c8 transparent;
      }
`;
export default NotificationDropDown;
